export const isValidEmail = (value) => {
  const reg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return reg.test(value)
}


var pwdReg = /提取码[:：]\s*([a-zA-Z\d]{4,6})[^a-zA-Z\d]/g
var pwdCsvReg = /\s*,\s*([a-zA-Z\d]{4,6})[^a-zA-Z\d]/g
var panLinkReg = /((pan\.baidu\.com\/s)|(yun\.baidu\.com\/s)|(www\.aliyundrive\.com\/s)|(www\.alipan\.com\/s)|(pan\.quark\.cn\/s)|(pan\.xunlei\.com\/s))\/([a-zA-Z0-9_\?\=\&\.%\+\#\-\/]+)/g

/**
 *
 * @param {String} s
 * @returns {[string[] , string[]]}
 * 
 * 读取文本中的网盘链接，并在链接附近查找提取码
 */
function linkAndPwdFromText(s) {
  const matches = [...s.matchAll(panLinkReg)]
  if (matches.length === 0) {
    return [[], []]
  }
  const links = matches.map(m => `https://${m[0]}`)
  const pwdArr = new Array(links.length).fill('')
  const maxEnd = s.length

  matches.forEach((match, idx) => {
    const matchStart = match.index
    const matchEnd = match.index + match[0].length
    const start = Math.max(0, matchStart - 0) // 关闭前查找范围
    const end = Math.min(maxEnd, matchEnd + 15)
    const before = s.slice(start, matchStart)
    const after = s.slice(matchEnd, end)

    let pwd = ''
    let beforePwd = ''
    let afterPwd = ''

    const beforeMatch = [...before.matchAll(pwdReg)]
    if (beforeMatch.length > 0) {
      const lastMatch = beforeMatch[beforeMatch.length - 1]
      beforePwd = lastMatch[1]
      pwd = beforePwd
    }

    const afterMatch = [...after.matchAll(pwdReg)]
    if (afterMatch.length > 0) {
      const firstMatch = afterMatch[0]
      afterPwd = firstMatch[1]
      pwd = afterPwd
    }

    if (beforePwd && afterPwd) {
      // 两边都有密码，检查后面的密码和链接是否在同一行
      if (after.indexOf('\n') >= 0 && after.indexOf(afterPwd) > after.indexOf('\n')) {
        pwd = beforePwd
      }
    }

    const pwdCsvMatch = [...after.matchAll(pwdCsvReg)]
    if (pwdCsvMatch.length > 0) {
      const firstMatch = pwdCsvMatch[0]
      pwd = firstMatch[1]
    }
    try {
      const url = new URL(links[idx])
      const urlPwd = url.searchParams.get('pwd')
      if (urlPwd) {
        pwd = urlPwd
      }
    } catch (e) {
      console.warn('Invalid URL:', links[idx], e)
    }
    pwdArr[idx] = pwd
  })

  return [links, pwdArr]
}

export function extractPanLinksAndPwds(s) {
  // [string, string][]
  const result = []
  const [links, pwds] = linkAndPwdFromText(s)
  for (let i = 0; i < links.length; i++) {
    result.push([links[i], pwds[i]])
  }
  return result
}

// console.log('validate.js loaded', extractPanLinksAndPwds(`这是一个测试文本
// 链接在前面 提取码: abcd
// https://pan.baidu.com/s/1abcd

// 链接在后面
// https://pan.baidu.com/s/1efgh 提取码: efgh

// 链接和提取码不在同一行
// https://pan.baidu.com/s/1ijkl
// 提取码: ijkl

// 链接带pwd参数
// https://pan.baidu.com/s/1mnop?pwd=mnop

// 链接带pwd参数和文本提取码
// https://pan.baidu.com/s/1qrst?pwd=qrst
// 提取码: uvwx

// 链接没有提取码
// https://pan.baidu.com/s/1yzab
// https://pan.quark.cn/s/c25edb04bff1#/list/share/c8bebfecf9c24d1b890c914f6b1cecd9
// https://pan.quark.cn/s/c25edb04bff1#/list/share/c8bebfecf9c24d1b890c914f6b1cecd9,1245
// `));